/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import TariffInterface, { TariffCollectionInterface } from '../../interfaces/billing/TariffInterface';
import { tariffConstants } from './actions';

const _ = require('underscore');

export type LoadTariffsType = {
    callback: () => void;
    filters: Array<Filter>;
    orders: Array<Order>;
};

export class TariffsLoader {
    private itemLoaders: ItemLoaders;

    private tariffs: TariffCollectionInterface | null;

    private tariffsHeaderList: Array<HeaderCheckBoxSelectListElement> | null;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoaders = itemLoader;
        this.tariffs = null;
        this.tariffsHeaderList = null;
    }

    loadTariffs = (params: LoadTariffsType): void => {
        this.itemLoaders.getListWithCallback(
            FormGeneralHelper.getUrl('/tariffs'),
            tariffConstants.LIST,
            params.filters,
            params.orders,
            (data: TariffCollectionInterface): void => {
                this.tariffs = data;
                this.tariffsHeaderList = null;
                params.callback();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    getHeaderList = (): Array<HeaderCheckBoxSelectListElement> => {
        if (!this.tariffsHeaderList) {
            const list: Array<HeaderCheckBoxSelectListElement> = [];
            if (!this.tariffs || this.tariffs['hydra:totalItems'] === 0) {
                return list;
            }
            this.tariffs['hydra:member'].map((item: TariffInterface) => {
                list.push({ name: item.tariffName, value: item.id });
            });
            this.tariffsHeaderList = list;
        }
        return this.tariffsHeaderList;
    };

    getItemById = (stateId: number): TariffInterface | null => {
        if (this.tariffs) {
            return _.find(this.tariffs?.['hydra:member'], (item: TariffInterface) => {
                return item.id === stateId;
            });
        }
        return null;
    };

    getName = (stateId: number): string | null => {
        const obj = this.getItemById(stateId);
        if (!obj) {
            return null;
        }
        return obj.tariffName;
    };

    getIdByName = (tariffName: string): number | null => {
        const obj = _.find(this.getHeaderList() ?? [], (item: HeaderCheckBoxSelectListElement) => {
            return item.name.toLowerCase() === tariffName.toLowerCase();
        });

        if (!obj) {
            return null;
        }

        return obj.value;
    };
}
